import React, { useContext, useState } from "react";
import CustomUploader from "../../../../components/CustomUpload/CustomUploader";
import { Button, Input, Switch } from "antd";
import TextArea from "antd/es/input/TextArea";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { createGoods } from "../../../../service/shopApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import FileKeysContext from "../../../../context/fileKeysContext";
function AddNewGood({ setAddGoods, shopData }) {
  const [saleable, setSaleable] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const { shopImagesKeys, resetFileKeysContext } = useContext(FileKeysContext);

  const queryClinet = useQueryClient();
  const nemGoodMutation = useMutation(createGoods, {
    onSuccess: () => {
      setAddGoods(false);
      queryClinet.invalidateQueries({
        queryKey: ["expertShop"],
      });
      resetFileKeysContext()
    },
  });
  const categoryId = shopData?.id;

  return (
    <section className="bg-white h-full rounded-lg gap-3 flex flex-row max-lg:flex-col  ">
      <div className="flex flex-col max-lg:flex-col-reverse justify-between w-[55%] max-lg:w-full p-3 h-full max-lg:gap-4 ">
        <div className="flex flex-col text-right  ">
          <label>تصویر محصول:</label>
          <div className="max-lg:h-[120px] overflow-y-scroll max-lg:w-full text-center">
            {<CustomUploader type="shop-image" />}
          </div>
        </div>
        <div className="flex flex-col max-lg:flex-row gap-16 max-lg:gap-2">
          <div className="flex flex-col text-right gap-5 max-lg:gap-2">
            <label>عنوان محصول:</label>
            <Input
              placeholder="عنوان محصول خود را وارد کنید"
              maxLength={51}
              required={true}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="flex flex-row max-lg:flex-col whitespace-nowrap items-center justify-between">
            <label>وضعیت محصول:</label>
            <div>
              <Switch
                checkedChildren={"موجود"}
                unCheckedChildren={"ناموجود"}
                onChange={(e) => setSaleable(e)}
                className=" bg-red-500 :!bg-green-400 hover:bg-pink-300 !font-body"
                defaultChecked={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className=" bg-[#F5F5F5] shadow-inner flex flex-col p-3 w-[50%] max-lg:w-full h-full justify-between rounded-r-xl rounded-l-lg">
        <div className="text-right flex flex-col gap-3">
          <label>توضیحات محصول:</label>
          <TextArea
            onChange={(e) => setDescription(e.target.value)}
            className="!font-body"
            maxLength={400}
            allowClear
            showCount
            autoSize={{ minRows: 8, maxRows: 10 }}
            placeholder="توضیحات خود را وارد کنید..."
          />
        </div>
        <div className="flex flex-row justify-end gap-5 max-lg:mt-6 max-lg:m-auto ">
          <Button
            loading={nemGoodMutation.isLoading}
            danger
            className="w-[130px]"
            type="primary"
            icon={<CloseOutlined />}
            onClick={() => setAddGoods(false)}
          >
            لغو
          </Button>
          <Button
            loading={nemGoodMutation.isLoading}
            type="primary"
            className="bg-[#005AC8] w-[130px]"
            icon={<CheckOutlined />}
            onClick={() =>
              nemGoodMutation.mutate({
                saleable: saleable,
                title: title,
                description: description,
                categoryId: categoryId,
                images: shopImagesKeys,
              })
            }
          >
            ثبت محصول
          </Button>
        </div>
      </div>
    </section>
  );
}

export default AddNewGood;
